import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    button:{
        color: theme.palette.gray_400.main,
        borderRadius: 8,
        boxShadow: 'none',
        '&:hover': {
            textDecoration: 'underline',
            boxShadow: 'none',
            backgroundColor: 'transparent'
        }
    }
}))